<template>
	<div>
        <table >
            <thead>
                <tr>
                    <td class="rank">排名</td>
                    <td>球员</td>
                    <td>球队</td>
                    <td v-if="type=='shooters'" class="goals">进球数</td>
                    <td v-if="type=='assists'"  class="goals">助攻数</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item,i in detail" :key="i">
                    <td class="rank">{{i+1}}</td>
                    <td>{{item.player_name}}</td>
                    <td>
                        <img :src="item.team_logo"/>
                        {{item.team_name}}
                    </td>
                    <td  v-if="type=='shooters'"  class="goals">{{item.goals + item.penalty_goals}}</td>
                    <td  v-if="type=='assists'"  class="goals">{{item.assist}}</td>
                </tr>
            </tbody>
            <div v-if="detail.length<=0" class="nodata">
                暂无数据
            </div>
        </table>
	</div>
</template>

<script>
import axios from "axios";
export default {
	data() {
		return {
		}
	},
    props: ['detail','type'],
	created() {
	},
	beforeMount() {

	},
	computed:{

		
	},	
	methods: {

	},
}
</script>

<style lang="less" scoped>
    .title{
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #fff;
        background: #e24949;
        font-size: 18px;
    }
    thead tr {
        border: none;    
    }
    table{
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
        margin-bottom:20px;
        thead{
            width: 100%;
            tr{
                background: #e24949;
                color: #fff;
                height: 48px;
                line-height: 48px;
                border-bottom: 1px solid #ededed;
                text-align: left;
                
            }
        }
        tbody{
            width: 100%;
            tr{
                background: #fff;
                color: #333;
                height: 50px;
                line-height: 50px;
                border-bottom: 1px solid #e7f7eb;
                text-align: left;
                img{
                    width: 30px;
                    height: 30px;
                    margin:0 10px 0 0;
                    position: relative;
                    bottom: -10px;
                }
            }
        }
        .rank{
            width:100px;
            text-align: left;
            padding-left: 20px;
            img{
                width: 30px;
                height: 30px;
                margin:0 10px 0 0;
                position: relative;
                bottom: -10px;
            }
        }
        .nodata{
            width: 940px;
            text-align: center;
            height: 400px;
            line-height: 400px;
            color: #999;
        }
        .goals{
            text-align: center;
        }

    }
</style>
